import { FormattedMessage } from 'react-intl'
import { useRouteMatch } from 'react-router-dom'

import InformationContent from '@components/UI/Information/Content/Content'
import UpsellInformation from '@components/Upsell/Information/Information'
import { EventTrackingNames } from '@enums'
import { selectCampaignId } from '@store/router'
import Theme from '@theme'
import { Container, Text } from '@tribegroup'

interface IAnalyticsDetailCardTooltip {
  title: React.ReactNode
  content: React.ReactNode
  productMetricGroup?: string
  productMetricValue?: string
  locked?: boolean
  externalLink?: string
  showAsterisk?: boolean
}

const AnalyticsDetailCardTooltip: React.FC<IAnalyticsDetailCardTooltip> = ({
  title,
  content,
  locked,
  externalLink,
  productMetricValue,
  productMetricGroup,
  showAsterisk,
}) => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match)!

  return (
    <>
      <InformationContent
        titleColor={locked ? Theme.grey900Color : Theme.primaryColor}
        title={title}
        content={content}
      />

      {showAsterisk && (
        <Container topOuterSpacing={0.5}>
          <Container absolute leftPosition={0.75}>
            <Text medium color={Theme.grey900Color} customFontSize={0.8125}>
              <FormattedMessage id="core.text.symbol.attention" />
            </Text>
          </Container>
          <Text color={Theme.grey900Color} customFontSize={0.8125}>
            <FormattedMessage id="analytics.shortlistSummary.tooltipDisclaimer" />
          </Text>
        </Container>
      )}

      {locked && externalLink && (
        <UpsellInformation
          textInformationMaxWidth={9.75}
          textInformation={
            <FormattedMessage id="upsell.information.unlock" values={{ br: () => <br /> }} />
          }
          externalLink={externalLink}
          trackingProps={{
            eventName: EventTrackingNames.SubscriptionLearnMore,
            additionalProperties: {
              product_metric_group: productMetricGroup,
              product_metric: productMetricValue,
            },
            campaignId,
          }}
        />
      )}
    </>
  )
}

export default AnalyticsDetailCardTooltip
